import styled from "styled-components";

export const BotChatMessageFeedbackContainer = styled.div(
  (props) =>
    props?.theme?.themeConfig?.chatMessages?.botMessage?.feedback?.styles
);
